import axios from "axios";
import { TTP_API_URL } from "Config";

axios.defaults.baseURL = TTP_API_URL;
// axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
axios.interceptors.request.use(config => {
  // TODO add token, handle request cancellation ...
  return config;
});

export * from "./auth";
export * from "./media";
export * from "./article";
export * from "./user";
export * from "./webtool";
export * from "./wheretobill";
export * from "./survey";
export * from "./social";
export * from "./event";
export * from "./notif";
export * from "./topic";
export * from "./pellet";
export * from "./directory";
export * from "./dashboard";
export * from "./comment";
export * from "./ebox";
export * from "./filter";
export * from "./page";
export * from "./tamtamIt";



// WEBPACK FOOTER //
// ./src/api/index.js